import AOS from 'aos';
import 'aos/dist/aos.css';

import FrontBrands from '../../front/components/FrontBrands';
import FrontFooter from '../../front/components/FrontFooter';
import FrontHero from '../../front/components/FrontHero';
import FrontModules from '../../front/components/FrontModules';
import FrontNav from '../../front/components/FrontNav';
import FrontParticipantModule from '../../front/components/FrontParticipantModule';
import FrontResourcePersonModule from '../../front/components/FrontResourcePersonModule';
import FrontService from '../../front/components/FrontService';
import FrontStatModule from '../../front/components/FrontStatModule';
// import { Link } from 'react-router-dom';
// import EnrollButtonsSection from './sections/EnrollButtonsSection';
import EventsSection from './sections/EventsSection';

AOS.init();

function Home() {
  return (
    <div className="front">
      <FrontNav />
      <FrontHero />
      <FrontService />
      <FrontBrands />
      <FrontModules />
      <FrontParticipantModule />
      <FrontResourcePersonModule />
      <FrontStatModule />
      <div className="position-relative mt-n8">
        <div className="shape shape-bottom shape-fluid-x text-gray-200">
          <svg viewBox="0 0 2880 480" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2160 0C1440 240 720 240 720 240H0v240h2880V0h-720z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
      <section className="pt-12 pt-md-13 bg-gray-200">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12">
              {/* <EnrollButtonsSection /> */}
              <EventsSection />
            </div>
          </div>
        </div>
      </section>
      <section className="pt-9 pt-md-12 bg-gray-200"></section>
      <div className="position-relative mt-n15">
        <div className="shape shape-bottom shape-fluid-x text-dark">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <section className="pt-15 bg-dark" />
      <section className="py-8 py-md-11 bg-dark" />
      <div className="position-relative">
        <div className="shape shape-bottom shape-fluid-x text-gray-200">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
}

export default Home;
